export const REFERENCE_NODE = ' ';
export const DEFAULT_DOC_NAME = 'New Note';
